import {Stack, styled} from '@mui/material';

const ChargeTotalStack = styled(Stack)(() => ({
	paddingTop: 0,
}));

export {ChargeTotalStack};
